import { GetSportIcon } from 'assets/icons';
import { SportGlobelState } from 'features/sports/interface/interface';
import React from 'react';
import { useSelector } from 'react-redux';
import { SvgIcon } from 'shared/components/SvgIcon';
import { CategoriesStateInterface, State } from 'shared/interface';

interface CategoriesFlagProps {
	category: {
		sportId: number;
		parentCategory: number;
		categoryId: number;
	};
	className?: string;
}

export const GetCategoriesIcon: React.FC<CategoriesFlagProps> = (props) => {
	const allCategories = useSelector<State, CategoriesStateInterface['all']>((state) => state.categories?.all);
	const categoriesFlags = useSelector<State, SportGlobelState['categoriesFlags']>((state) => state.sport.categoriesFlags);

	let categoryData = props.category;
	if (props.category?.categoryId && allCategories[props.category.categoryId]) {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		categoryData = allCategories[props.category?.categoryId]!;
	}
	if (!categoryData) {
		return <GetSportIcon id={1} />;
	}

	let flag = categoriesFlags[categoryData.categoryId];
	if (!flag) {
		flag = categoriesFlags[categoryData.parentCategory];
	}
	if (!flag) {
		return <GetSportIcon id={categoryData.sportId} />;
	}

	return <SvgIcon type="category" iconId={flag} className={props.className} id={`category-icon-${flag}`} />;
};
